import { render } from "./EditPmLocal.vue?vue&type=template&id=db5e0e9c"
import script from "./EditPmLocal.vue?vue&type=script&lang=js"
export * from "./EditPmLocal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__